/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const FACEBOOK_ONETIME_OPTIN_DISPLAY_TYPE = 'Opt FB User in'
const FACEBOOK_ONETIME_OPTIN_WIDGET_TYPE = 'FB_OPT_IN_ONE_TIME'

const isFacebookOneTimeOptInAction = R.propEq(
  'type',
  FACEBOOK_ONETIME_OPTIN_DISPLAY_TYPE
)

const convertFacebookOneTimeOptInActionToWidgetAction = R.applySpec({
  type: R.always(FACEBOOK_ONETIME_OPTIN_WIDGET_TYPE)
})

export {
  isFacebookOneTimeOptInAction,
  convertFacebookOneTimeOptInActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-onetime-optin.js